import React, { useState } from "react";
import AuthLayout from "../AuthLayout";
import styles from "./forgotpassword.module.scss";
import Button from "../../Shared/Button";
import AuthTextField from "../AuthTextField";
import { forgotPassword } from "../../../helpers";
import CuteMascotSpinner from "../../../global/CuteMascotSpinner";
import { toast } from "react-toastify";
import logo from "../../../assets/images/logo/forgot.svg";
import { resetPassword } from "../../../helpers/service";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const [username, setUsername] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [openResetPassword, setOpenResetPassword] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetCode, setResetCode] = useState("");
  const [resetNewPassword, setResetNewPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmitForgotPassword = async () => {
    try {
      setLoading(true);
      const res = await forgotPassword({ email: username });

      if (res.success) {
        setLoading(false);
        setSuccess(true);
        toast.success(res.message);
      }
    } catch (error) {
      console.error("Error triggering forgot password:", error);
      // Set an error message based on the error code (see Cognito docs for error codes)
      if (error.code === "UserNotFoundException") {
        setMessage("User not found.");
      } else {
        setMessage("Error initiating password reset. Please try again later.");
      }
    }
  };

  const handleResetPassword = async () => {
    try {
      setLoading(true);
      const res = await resetPassword({
        email: resetEmail,
        code: resetCode,
        password: resetNewPassword,
      });

      if (res.success) {
        setLoading(false);
        // setSuccess(true);
        toast.success(res.message);

        navigate("/");
      }
    } catch (error) {
      console.error("Error triggering forgot password:", error);
      setLoading(false);
      // Set an error message based on the error code (see Cognito docs for error codes)
      if (error.code === "UserNotFoundException") {
        setMessage("User not found.");
      } else {
        setMessage("Error initiating password reset. Please try again later.");
      }
    }
  };

  return (
    <AuthLayout>
      <>
        {loading && <CuteMascotSpinner />}

        <>
          {openResetPassword ? (
            <div>
              <div className={styles["forgot_password_container"]}>
                <div className={styles["forgot_password_text"]}>
                  Reset password?
                </div>
                <div className={styles["label_container"]}>
                  Confirm your email. We will send you a secret code to confirm
                  your identity.
                </div>
                <div className={styles["email_field_container"]}>
                  <AuthTextField
                    heading="Email"
                    type="email"
                    onChange={(e) => setResetEmail(e.target.value)}
                    name="email"
                    value={resetEmail}
                  />
                  <div
                    style={{
                      marginTop: "10px",
                    }}
                  />
                  <AuthTextField
                    heading="Code"
                    type="text"
                    onChange={(e) => setResetCode(e.target.value)}
                    name="code"
                    value={resetCode}
                  />
                  <div
                    style={{
                      marginTop: "10px",
                    }}
                  />
                  <AuthTextField
                    heading="New Password"
                    type="password"
                    onChange={(e) => setResetNewPassword(e.target.value)}
                    name="password"
                    value={resetNewPassword}
                  />
                  <div className={styles["submit_button_container"]}>
                    <Button
                      type="submit"
                      className={styles["submit_button"]}
                      onClick={() => {
                        handleResetPassword();
                      }}
                      text="Submit"
                    />
                    {message && (
                      <p
                        style={{
                          color: "red",
                          fontSize: " 12px",
                          marginTop: "10px",
                        }}
                      >
                        {message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              {" "}
              {!success ? (
                <div className={styles["forgot_password_container"]}>
                  <div className={styles["forgot_password_text"]}>
                    Forgot password?
                  </div>
                  <div className={styles["label_container"]}>
                    Confirm your email. We will send you a secret code to
                    confirm your identity.
                  </div>
                  <div className={styles["email_field_container"]}>
                    <AuthTextField
                      heading="Email"
                      type="email"
                      onChange={(e) => setUsername(e.target.value)}
                      name="email"
                      value={username}
                    />
                    <div className={styles["submit_button_container"]}>
                      <Button
                        type="submit"
                        className={styles["submit_button"]}
                        onClick={() => {
                          handleSubmitForgotPassword();
                        }}
                        text="Next"
                      />
                      {message && (
                        <p
                          style={{
                            color: "red",
                            fontSize: " 12px",
                            marginTop: "10px",
                          }}
                        >
                          {message}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div className={styles["forgot_password_container"]}>
                  <div className={styles["forgot_password_wrapper"]}>
                    <div className={styles["logo_container"]}>
                      <img src={logo} alt="" />
                    </div>

                    <div className={styles["forgot_password_text_wrapper"]}>
                      <h2 className={styles["forgot_password_text_heading"]}>
                        Check your email for a reset link
                      </h2>
                      <p className={styles["forgot_password_text_paragraph"]}>
                        We just sent you an email with an reset link. Please
                        check your inbox and click on the link to reset your
                        password. If you don't see the email, check your spam
                        folder.{" "}
                      </p>
                    </div>

                    <div className={styles["forgot_password_button"]}>
                      <button onClick={() => setOpenResetPassword(true)}>
                        Reset Password
                      </button>
                    </div>
                  </div>
                </div>
              )}{" "}
            </>
          )}
        </>
      </>
    </AuthLayout>
  );
};

export default ForgotPassword;
